module.exports = {
  src: __webpack_public_path__ + "button-hover.png",
  width: 600,
  height: 33,
  bytes: 3836,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "button-hover.png";
};


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/timelinecase/button-hover.png
 ** module id = 1093
 ** module chunks = 0
 **/